/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterOutSelectedRegion'
})
export class FilterOutSelectedRegionPipe implements PipeTransform {
    transform(items: Array<any>, list: Array<any>, selectedRegion: any): Array<any> {
        list.forEach(function(element){
            items = items.filter(item => (item['id'] != element.region.id || item['id'] == selectedRegion));
        });
        return items;
    }
}

@Pipe({
    name: 'filterOutSelectedRegionByCode'
})
export class FilterOutSelectedRegionByCodePipe implements PipeTransform {
    transform(items: Array<any>, list: Array<any>, selectedRegionCode: any): Array<any> {
        list.forEach(function(element){
            items = items.filter(item => (item['code'] != element.earnedFromRegion || item['code'] == selectedRegionCode));
        });
        return items;
    }
}

@Pipe({
    name: 'filterSelectedRegion'
})
export class FilterSelectedRegionPipe implements PipeTransform {
    transform(items: Array<any>, selectedRegion: any): Array<any> {
        items = items.filter(item => (item['id'] != selectedRegion));
        return items;
    }
}